module.exports = __webpack_public_path__ + "img/nouser.36ca16a1.png";